import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import "./../styles/nav.css"
import burger from "./../assets/images/burger.svg"
import React, { useEffect, useState } from 'react';

function CollapsibleExample() {
    useEffect(() => {
        window.onscroll = function () { scrollFunction() };

        if (document.documentElement.scrollTop === 0) {
            document.getElementById("nav_id").style.top = "0";
        }

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                document.getElementById("nav_id").style.top = "0";
                // document.getElementById("nav_id").style.background = "inherit"
            } else {
                document.getElementById("nav_id").style.background = "rgba(34	40	49, 0.7)"
            }
        }


        let prevScrollPos = window.pageYOffset;

        window.addEventListener("scroll", () => {
            const currentScrollPos = window.pageYOffset;

            if (currentScrollPos > prevScrollPos) {
                document.getElementById("nav_id").style.top = "-65px";

            } else if (currentScrollPos < prevScrollPos) {
                if (document.documentElement.scrollTop === 0) {
                    // document.getElementById("nav_id").style.background = "inherit"
                } else {
                    document.getElementById("nav_id").style.background = "rgba(34	40	49, 0.7);"
                }

            }

            prevScrollPos = currentScrollPos;
        });
    }, [])



    return (
        <Navbar collapseOnSelect expand="lg" id="nav_id">
            <Container>
                <Navbar.Brand href="#home">
                    <img
                        alt=""
                        src="icon.png"
                        width="40"
                        height="40"
                        className="d-inline-block align-top me-2"
                    />{' '}
                    | Portfolio
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ backgroundImage: burger }} />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                    </Nav>
                    <Nav>
                        <Nav.Link className='' href="#about_id">About</Nav.Link>
                        <Nav.Link className='' href="#skills_id">Skills</Nav.Link>
                        <Nav.Link className='' href="#projects_id">Projects</Nav.Link>
                        
                        
                        <Nav.Link className='' href="#contact_id">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>

    );
}

export default CollapsibleExample;